











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamInsightsCard_insights",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TeamInsights",
  "abstractKey": null
};

(node ).hash = "dd03a941f26b037569839465c9e7db12";

export default node;
